import Vue from "vue";

import ViewListIcon from "vue-material-design-icons/ViewList";
import PencilIcon from "vue-material-design-icons/Pencil";

// Register the Icons so Webpack includes them and we can use them
Vue.component("ViewListIcon", ViewListIcon);
Vue.component("PencilIcon", PencilIcon);

export default [
  {
    name: "Projects",
    children: [
      {
        name: "Client",
        children: [
          {
            icon: "view-list",
            title: "List Client",
            to: {
              name: "ocom_client.list",
              query: { limit: 25, filter: "active", sort: "name" },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Client",
            to: { name: "ocom_client.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Project",
        children: [
          {
            icon: "view-list",
            title: "List Project",
            to: {
              name: "ocom_project.list",
              query: { limit: 25, filter: "active", sort: "name" },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Project",
            to: { name: "ocom_project.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },

      {
        name: "Timesheet Entry",
        children: [
          {
            icon: "view-list",
            title: "List Timesheet Entry",
            to: {
              name: "timesheet_entry.list",
              query: { limit: 10, filter: "all" },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Timesheet Entry",
            to: { name: "timesheet_entry.create" },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
    ],
  },
  {
    name: "Sales",
    children: [
      {
        name: "Quote",
        children: [
          {
            icon: "view-list",
            title: "List Quote",
            to: {
              name: "ocom_quote.list",
              query: {
                limit: 25,
                filter: "inprogress",
                sort: "created_date",
                order: "desc",
              },
            },
            loggedIn: true,
          },
          {
            icon: "pencil",
            title: "New Quote",
            to: { name: "ocom_quote.create" },
            loggedIn: true,
          },
        ],
      },
      {
        name: "Old Quotes",
        children: [
          {
            icon: "view-list",
            title: "List OLD Quotes",
            to: {
              name: "ocom_quote_old.list",
              query: { limit: 10, filter: "all" },
            },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
    ],
  },
  {
    name: "Admin",
    children: [
      {
        name: "Maintain",
        children: [
          {
            icon: "view-list",
            title: "List Language",
            to: {
              name: "language.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Framework",
            to: {
              name: "framework.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Database",
            to: {
              name: "database.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Login Type",
            to: {
              name: "code_login_type.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Front End",
            to: {
              name: "code_front_end.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Quote Type",
            to: {
              name: "code_quote_type.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Quote Status",
            to: {
              name: "code_quote_status.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List User Story Status",
            to: {
              name: "code_user_story_status.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Task Types",
            to: {
              name: "code_task_type.list",
              query: { limit: 25, filter: "active", sort: "description" },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Document Template",
            to: {
              name: "document_template.list",
              query: { limit: 10, filter: "all" },
            },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        name: "Users & Roles",
        children: [
          {
            icon: "view-list",
            title: "List Users",
            to: {
              name: "user.list",
              query: {
                limit: 25,
                filter: "active",
                sort: "email",
                order: "asc",
              },
            },
            loggedIn: true,
          },
          {
            icon: "view-list",
            title: "List Groups",
            to: {
              name: "group.list",
              query: { limit: 25, filter: "all", sort: "name", order: "asc" },
            },
            loggedIn: true,
          },

          {
            icon: "view-list",
            title: "List Group Permissions",
            to: {
              name: "group_permissions.list",
              query: {
                limit: 25,
                filter: "all",
                sort: "group",
                order: "asc",
              },
            },
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
    ],
  },
];
